import React, { useState } from "react";
import { Form, Input, Button, message, notification } from "antd";  // ✅ notification import
import api from "../api/axios";

export default function Login({ onLoginSuccess }) {
    const [loading, setLoading] = useState(false);

    const onFinish = values => {
        setLoading(true);
        api.post('/api/login', values)
            .then(res => {
                if (res.data.token) {
                    localStorage.setItem('token', res.data.token);
                    onLoginSuccess();
                }
            })
            // Login.js .catch() - REPLACE WITH THIS
            .catch(err => {
                const msg = err.response?.data?.error || "Login failed";
                //console.log('❌ Login error:', msg);

                // ✅ NATIVE ALERT - IMPOSSIBLE TO MISS
                alert(`Login Failed\n\n${msg}`);

                // Still try notification
                try {
                    notification.error({
                        message: 'Login Failed',
                        description: msg,
                        duration: 8,
                        placement: 'top'
                    });
                } catch(e) {
                    console.log('Notification failed:', e);
                }
            })

            .finally(() => setLoading(false));
    };

    return (
        <Form onFinish={onFinish} style={{ maxWidth: 320, margin: "32px auto" }}>
            <h2>Login</h2>
            <Form.Item name="username" rules={[{ required: true, message: "Enter username" }]}>
                <Input placeholder="Username" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "Enter password" }]}>
                <Input.Password placeholder="Password" />
            </Form.Item>
            <Button block type="primary" htmlType="submit" loading={loading}>
                Login
            </Button>
        </Form>
    );
}
